<template>
  <div class="electricity">
      <h4>Electricity</h4>
      <ElectricChart />
  </div>
</template>
<script>
import ElectricChart from './ElectricChart.vue';

export default {
  name: "Electricity",
  components: {
    ElectricChart,
  }
};

</script>
<style>
h4, span {
  color: #AAAAAA;
}
</style>
